import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { SmileyIcon } from '@karma/components/icons';
import { Button, Stack, Typography } from '@karma/components';
import * as ALOOMA from 'consts/alooma';
import Alooma from 'services/alooma';
import withIosBugFixCaret from 'hocs/withIosBugFixCaret';

const ModalBodyWithdrawCongrats = ({ closeModal, iosBugHideHandler, iosBugShowHandler }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();

  const close = () => {
    iosBugHideHandler();
    closeModal();
  };

  useEffect(() => {
    iosBugShowHandler();
  }, [iosBugShowHandler]);

  return (
    <Stack direction="column" spacing={20}>
      <SmileyIcon width={60} height={60} />
      <Stack direction="column" spacing={8}>
        <Typography variant="h3">{t('app:youHaveWithdrawnCashBack')}</Typography>
        <Typography variant="paragraphLarge">{t('app:toAccessYourEarnings')}</Typography>
      </Stack>
      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.GOT_IT}
        size="medium"
        onClick={close}
        fullWidth
      >
        {t('app:gotIt')}
      </Button>
    </Stack>
  );
};

ModalBodyWithdrawCongrats.propTypes = {
  closeModal: PropTypes.func.isRequired,
  iosBugHideHandler: PropTypes.func.isRequired,
  iosBugShowHandler: PropTypes.func.isRequired,
};

export default withIosBugFixCaret()(ModalBodyWithdrawCongrats);
